/**
 * component config
 *
 * @author Shigq
 * @date 2021/11/12 16:23
 */
const component = {
	loading: {
		text: '正在加载中...',
		background: 'hsla(0,0%,100%,.8)'
	},
	message: {
		offset: 60,
		message: "操作成功",
		type: 'success',
		duration: 3000
	},
	messageBox: {
		title: '温馨提示',
		content: '操作成功！',
		confirmButtonText: '确定',
		cancelButtonText: '取消',
		type: 'warning'
	},
	timer: {
		duration: {
			default: 10,
			code: 60,
			txn: 15,
		},
		millisecond: 1000
	},
	pagination: {
		currentPage: 1,
		total: 0,
		pageSize: 10,
		pageSizes: [1,5, 10, 20, 50],
		layout: 'total, sizes, prev, pager, next'
	},
}

module.exports = component
